import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import SelectAccountLayout from "../../Component/Layouts/SelectAccountLayout";

const mdTheme = createTheme();

function SelectAccount() {

  
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ 
        display: "flex", 
        height: "100vh",
        overflow: "hidden"
      }}>
        <CssBaseline />
        <SelectAccountLayout />
      </Box>
    </ThemeProvider>
  );
}

export default SelectAccount; 